import React, { useCallback, useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { SingleValue, ActionMeta } from "react-select";
import Dropdown from "../home/Dropdown";
import { ReactComponent as DownloadIcon } from "../../assets/download.svg";
import { ReactComponent as DeleteIcon } from "../../assets/delete.svg";
import { ReactComponent as TrashIcon } from "../../assets/trash-grey.svg";
import { ReactComponent as NewDocumentIcon } from "../../assets/create_session.svg";
import { ReactComponent as EditIconSvg } from "../../assets/edit-icon-grey.svg";
import {
  TIME_ZONES,
} from "../../utils/sessionHelper";
import { MdOutlineEdit } from "react-icons/md";
import {
  AppDispatch,
  RootState,
  deleteDocumentSessionRequest,
  deleteRequest,
  getOfficials,
  updateRequestDetail,
  updateSessionDetail,
  updateSessionRequestInStore,
} from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { API_STATUS } from "../../utils";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useNavigate } from "react-router-dom";

import { ToastContentProps, toast } from "react-toastify";
import RequestDocumentPopup from "../home/RequestDocumentPopup";
import UploadLinkPopup from "../home/UploadLinkPopup";
import Counter from "../home/Counter";
import FloatingLabelTextarea from "../home/StyledTextarea";
import { CustomCloseButton } from "../ToasterCloseButton";
import { getFromLocalStorage } from "../../utils/localStorageUtil";
import { notaryLink } from "../../utils/helper";
import AddDocPopup from "./AddDocPopop";
interface OptionType {
  value: string;
  label: string;
}

const signersOptions: OptionType[] = [
  { value: "yes", label: "Multiple" },
  { value: "no", label: "Single" },
];


const labelMapping: { [key: string]: string } = {
  signerName: "Signer name",
  userEmail: "Signer email",
  signerPhone: "Signer phone",
  userTimezone: "Signer timezone",
  cc: "Copy recipient 1",
  copy2: "Copy recipient 2",
  payerEmail: "Payer email",
  multipleSigner: "Signer(s)",
  appointmentType: "Session type",
};

const SessionSummary: React.FC<{
  session: any;
  activeSessionId?: string;
}> = ({ session, activeSessionId }) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [isNotesEditable, setIsNoteEditable] = useState(false);
  const { data: appointmentTypes, loading } = useSelector(
    (state: RootState) => state.session.appointmentTypes
  );
  const [documents, setDocuments] = useState(session?.documents || []);
  const [isAddDocPopupOpen, setIsAddDocPopupOpen] = useState(false);
  const [deleteDocId, setDeleteDocId] = useState(null);
  const [selectedNotaryOwner, setSelectedNotaryOwner] = useState<any>();
  const [iframeUrl, setIframeUrl] = useState<string>(``);
  const [isUploadLinkPopupOpen, setIsUploadLinkPopupOpen] = useState(false);
  const [isNotesLoading, setIsNotesLoading] = useState(false);

  const [selectedAppointmentType, setSelectedAppointmentType] = useState<OptionType>(
    appointmentTypes.find((type) => type.value === session?.appointmentType) ||
    appointmentTypes[0]
  );
  const [isLoadingUpdateSignerDetail, setIsLoadingUpdateSignerDetail] = useState(false);

  const [isRequestDocPopupVisible, setIsRequestDocPopupVisible] =
    useState(false);
  const [textareaValue, setTextareaValue] = useState(
    !session?.officialPrivateNotes ? session?.message : session?.officialPrivateNotes || ""
  );
  const [updatedDocumentSeal, setUpdatedDocumentSeal] = useState<number | null>(
    null
  );
  const [isDocumentSealEditable, setIsDocumentSealEditable] = useState(false);

  const [selectedSessionStage, setSelectedSessionStage] = useState<OptionType>({
    value: session?.stage,
    label: session?.stage,
  });
  const [selectedDocumentSeal, setSelectedDocumentSeal] = useState<number>(
    session?.documentsCount || 0
  );
  const [updatedNotaryOwner, setUpdatedNotaryOwner] = useState<any>(null);
  const [isNotaryOwnerEditable, setIsNotaryOwnerEditable] = useState(false);
  const [isDeleteDocPopupVisible, setIsDeleteDocPopupVisible] = useState(false);

  const {
    updatingSession: { loading: updateLoading },
  } = useSelector((state: RootState) => state.session);

  const [isDateEditable, setIsDateEditable] = useState(false);
  const [isDeleteDocLoading, setIsDeleteDocLoading] = useState(false);

  // const [selectedDate, setSelectedDate] = useState<Date>(
  //   session?.date ? new Date(session.date) : new Date("July 5, 2024")
  // );
  const [isAssignmentAvailable, setIsAssignmentAvailable] = useState(false);
  const [assignedToNotaryId, setAssignedToNotaryId] = useState("");
  const initialDate = new Date(session?.requestedDatetime);
  const [officials, setOfficials] = useState<any[]>([]);
  const [sessionDate, setSessionDate] = useState<Date>(initialDate);
  const [tempDate, setTempDate] = useState<Date>(initialDate);
  const [isDeleteRequestPopupVisible, setIsDeleteRequestPopupVisible] =
    useState(false);
  const [isDeleteRequestLoading, setIsDeleteRequestLoading] = useState(false);
  const [isNotaryOfficialSaveLoading, setIsNotaryOfficialSaveLoading] =
    useState(false);
  const [isDocSealSaveLoading, setIsDocSealSaveLoading] =
    useState(false);
  const [isSessionDetailsEditable, setIsSessionDetailsEditable] =
    useState(false);
  const [updatedStage, setUpdatedStage] = useState<OptionType | null>(null);

  const [signerDetail, setSignerDetail] = useState({
    userEmail: session?.userEmail || "",
    payerEmail: session?.payerEmail || "",
    cc: session?.cc || "",
    copy2: session?.copy2 || "",
    appointmentType: session?.appointmentType || "",
    multipleSigner: session?.multipleSigner
      ? (session.multipleSigner === "yes" ? "yes" : "no")
      : "",
    signerPhone: session?.signerPhone || "",
    userTimezone: session?.userTimezone || "",
  });
  const [isSignerDetailEditable, setIsSignerDetailEditable] = useState(false);
  const [isNotaryAdmin, setIsNotaryAdmin] = useState(false);

  const datePickerRef = useRef<HTMLDivElement>(null);
  const personaClientRef = useRef<any>(null);

  const handleSignerDetailChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setSignerDetail((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSignerDetailEditClick = () => {
    setIsSignerDetailEditable(true);
  };

  const handleEditSessionRequestDocuments = () => {
    if (!session?.appointmentId || !notaryLink) return;

    const link = `${notaryLink}/#/session-request-documents/${session.appointmentId}`;
    const newWindow = window.open(link, "newwindow", "width=1200,height=1100");

    if (!newWindow) {
      console.error("Popup blocked. Enable popups for this site.");
    }
  };

  const handleSignerDetailSave = async () => {
    try {
      setIsLoadingUpdateSignerDetail(true);
      let updatingSignerDetail = {};
      if (signerDetail.hasOwnProperty('payerEmail')) {
        updatingSignerDetail = {
          ...updatingSignerDetail,
          payerEmail: signerDetail.payerEmail,
        };
      }
      if (signerDetail.hasOwnProperty('userEmail')) {
        updatingSignerDetail = {
          ...updatingSignerDetail,
          userEmail: signerDetail.userEmail,
        };
      }
      if (signerDetail.hasOwnProperty('signerPhone')) {
        updatingSignerDetail = {
          ...updatingSignerDetail,
          signerPhone: signerDetail.signerPhone,
        };
      }
      if (signerDetail.hasOwnProperty('userTimezone')) {
        updatingSignerDetail = {
          ...updatingSignerDetail,
          userTimezone: signerDetail.userTimezone,
        };
      }
      if (signerDetail.hasOwnProperty('copy2')) {
        updatingSignerDetail = {
          ...updatingSignerDetail,
          copy2: signerDetail.copy2,
        };
      }
      if (signerDetail.hasOwnProperty('cc')) {
        updatingSignerDetail = {
          ...updatingSignerDetail,
          cc: signerDetail.cc,
        };
      }
      if (signerDetail.hasOwnProperty('appointmentType')) {
        const appointment = appointmentTypes.find(item => item.type === signerDetail?.appointmentType);
        updatingSignerDetail = {
          ...updatingSignerDetail,
          appointmentType: appointment.id,
        };
      }
      if (signerDetail.hasOwnProperty('multipleSigner')) {
        updatingSignerDetail = {
          ...updatingSignerDetail,
          multipleSigner: signerDetail.multipleSigner === "yes" ? "yes" : "no",
        };
      }
      await handleUpdateDetails({ ...updatingSignerDetail }, "signerDetail");
      setIsSignerDetailEditable(false);
    }
    catch (err) {

    }
    finally {
      setIsLoadingUpdateSignerDetail(false);

    }
  };

  const handleChangeSessionStage = useCallback(
    (newValue: SingleValue<OptionType>, actionMeta: ActionMeta<OptionType>) => {
      if (newValue && newValue.value !== session?.stage) {
        setSelectedSessionStage(newValue);
        setUpdatedStage(newValue);
        setIsSessionDetailsEditable(true);
      } else {
        setIsSessionDetailsEditable(false);
      }
    },
    [session]
  );

  const handleSignerDetailCancel = () => {
    setIsSignerDetailEditable(false);
    setSignerDetail({
      userEmail: session?.userEmail || "",
      payerEmail: session?.payerEmail || "",
      cc: session?.cc || "",
      copy2: session?.copy2 || "",
      appointmentType: session?.appointmentType || "",
      multipleSigner: session?.multipleSigner == "yes" ? "yes" : "no",
      signerPhone: session?.signerPhone || "",
      userTimezone: session?.userTimezone || "",
    });
  };

  const handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTextareaValue(e.target.value);
    adjustTextareaHeight();
  };

  const handleTextareaFocus = () => {
    setIsNoteEditable(true);
  };

  const handleTextareaBlur = () => {
    adjustTextareaHeight();
  };

  const adjustTextareaHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  };

  useEffect(() => {
    adjustTextareaHeight();
  }, [textareaValue]);

  const handleNotesCancel = () => {
    setTextareaValue(!session?.officialPrivateNotes ? session?.message : session?.officialPrivateNotes || "");
    adjustTextareaHeight();
    setIsNoteEditable(false);
  };

  const handleNotesSave = async () => {
    try {
      setIsNotesLoading(true);
      let previousState = {
        extensions: {
          officialPrivateNotes: session?.officialPrivateNotes
        }
      };
      const updateSessionDetailResponse = await dispatch(
        updateRequestDetail({
          details: {
            extensions: {
              officialPrivateNotes: textareaValue
            }
          },
          requestId: session?.id,
        })
      );
      if (updateSessionDetailResponse.meta.requestStatus == "fulfilled") {

        toast.success("Details have been updated",
          { autoClose: 3000, closeButton: <CustomCloseButton />, closeOnClick: false, icon: () => null, }
        );
      }
      if (updateSessionDetailResponse.meta.requestStatus == "rejected") {
        toast.error("Something went wrong", { autoClose: 3000, closeButton: <CustomCloseButton />, closeOnClick: false, icon: () => null, }
        );
      }

    } catch (err: any) {
      setIsNotesLoading(false);
      console.log("error", err);
    }
    finally {
      setIsNoteEditable(false);
      setIsNotesLoading(false);
      adjustTextareaHeight();
    }
  };

  const openDeleteDocPopup = () => setIsDeleteDocPopupVisible(true);
  const closeDeleteDocPopup = () => setIsDeleteDocPopupVisible(false);

  const handleChangeNotaryOwner = useCallback(
    (newValue: SingleValue<OptionType>, actionMeta: ActionMeta<OptionType>) => {
      const selectedOfficial = officials.find(
        (official) => official.name === newValue?.value
      );

      if (
        selectedOfficial &&
        selectedOfficial.name !== session?.official?.name
      ) {
        setSelectedNotaryOwner({
          value: selectedOfficial.name,
          label: selectedOfficial.name,
        });
        setAssignedToNotaryId(selectedOfficial?.uid)
        if (selectedOfficial?.commissionExpirationDate) {
          const date = new Date(
            selectedOfficial?.commissionExpirationDate?._seconds * 1000
          );
          const formattedDate = date.toString();
          selectedOfficial["commissionExpirationDate"] = formattedDate;
        }
        setUpdatedNotaryOwner(selectedOfficial);
        setIsNotaryOwnerEditable(true);
        setIsDocumentSealEditable(false)
      } else {
        setIsNotaryOwnerEditable(false);
      }
    },
    [officials, session]
  );

  const handleNotaryOwnerSave = async () => {
    try {
      setIsNotaryOfficialSaveLoading(true);
      if (updatedNotaryOwner) {
        let previousState = {
          assignedToUserId: session?.assignedToUserId,
          assignedToFirmId: session?.assignedToFirmId,
        };
        const updateSessionDetailResponse = await dispatch(
          updateRequestDetail({
            details: {
              assignedToUserId: updatedNotaryOwner?.uid,
              assignedToFirmId: updatedNotaryOwner?.firmId,
            },
            requestId: session?.id,
          })
        );
        if (updateSessionDetailResponse.meta.requestStatus == "fulfilled") {
          setIsNotaryOwnerEditable(false);
          setUpdatedNotaryOwner(null);
          setIsNotaryOfficialSaveLoading(false);
          toast.success(
            "Details have been updated",
            { autoClose: 3000, closeButton: <CustomCloseButton />, closeOnClick: false, icon: () => null, }
          );
        }
        if (updateSessionDetailResponse.meta.requestStatus == "rejected") {
          setIsNotaryOfficialSaveLoading(false);
          toast.error("Something went wrong", { autoClose: 3000, closeButton: <CustomCloseButton />, closeOnClick: false, icon: () => null, });
        }
      }
    } catch (err) {
      setIsNotaryOfficialSaveLoading(false);
    }
  };

  const handleDocSealSave = async () => {
    try {
      setIsDocSealSaveLoading(true);
      const updateSessionDetailResponse = await dispatch(
        updateRequestDetail({
          details: {
            documentsCount: selectedDocumentSeal,
          },
          requestId: session?.id,
        })
      );
      if (updateSessionDetailResponse.meta.requestStatus == "fulfilled") {
        setIsDocSealSaveLoading(false);
        dispatch(updateSessionRequestInStore({
          sessionId: session.id,
          updates: { documentsCount: selectedDocumentSeal }
        }));
        setSelectedDocumentSeal(selectedDocumentSeal || 0);
        setUpdatedDocumentSeal(null);
        toast.success("Details have been updated",
          { autoClose: 3000, closeButton: <CustomCloseButton />, closeOnClick: false, icon: () => null, }
        );
        setIsDocumentSealEditable(false)
      }
      if (updateSessionDetailResponse.meta.requestStatus == "rejected") {
        setIsDocSealSaveLoading(false);
        toast.error("Something went wrong", { autoClose: 3000, closeButton: <CustomCloseButton />, closeOnClick: false, icon: () => null, }
        );
      }

      // console.
      // if (updatedNotaryOwner) {
      //   let previousState = {
      //     assignedToUserId: session?.assignedToUserId,
      //     assignedToFirmId: session?.assignedToFirmId,
      //   };
      //   const updateSessionDetailResponse = await dispatch(
      //     updateRequestDetail({
      //       details: {
      //         assignedToUserId: updatedNotaryOwner?.uid,
      //         assignedToFirmId: updatedNotaryOwner?.firmId,
      //       },
      //       requestId: session?.id,
      //     })
      //   );
      //   if (updateSessionDetailResponse.meta.requestStatus == "fulfilled") {
      //     setIsDocSealSaveLoading(false);
      //     setUpdatedNotaryOwner(null);
      //     toast.success(
      //       ({ closeToast }: ToastContentProps) => (
      //         <div>
      //           <span>Details have been updated</span>
      //           <button
      //             onClick={() => {
      //               handleUndo(previousState);
      //               closeToast();
      //             }}
      //             style={{
      //               marginLeft: "10px",
      //               background: "none",
      //               border: "none",
      //               color: "#007bff",
      //               cursor: "pointer",
      //               textDecoration: "underline",
      //             }}
      //           >
      //             Undo
      //           </button>
      //         </div>
      //       ),
      //       {
      //         autoClose: 3000,
      //       }
      //     );
      //   }
      //   if (updateSessionDetailResponse.meta.requestStatus == "rejected") {
      //     setIsDocSealSaveLoading(false);
      //     toast.error("Something went wrong", {
      //       autoClose: 3000,
      //     });
      //   }
      // }
    } catch (err) {
      setIsDocSealSaveLoading(false);
    }
  };

  const handleNotaryOwnerCancel = () => {
    setIsNotaryOwnerEditable(false);
    // setUpdatedNotaryOwner(null);
    setSelectedNotaryOwner({
      value: session?.official?.name,
      label: session?.official?.name,
    });
    setAssignedToNotaryId(session?.assignedToUserId)
  };
  const handleDocSealCancel = () => {
    setIsDocSealSaveLoading(false);
    setIsDocumentSealEditable(false)
    setUpdatedNotaryOwner(null);
    setSelectedDocumentSeal(session?.documentsCount);
    setSelectedNotaryOwner({
      value: session?.official?.name,
      label: session?.official?.name,
    });
    setAssignedToNotaryId(session?.assignedToUserId)

  };

  const generateSecurityCredentials = function (securityParams: any) {
    if (!securityParams) {
      console.error("No security credentials provided!");

      return false;
    }

    return Object.keys(securityParams)
      .map(function (param) {
        return param + "=" + securityParams[param];
      })
      .join("&");
  };

  const createOfficialLink = (notaryAppLink: any, security: any) => {
    return (
      notaryAppLink + "?" + generateSecurityCredentials(security) + "#/official"
    );
  };

  const getDocumentFileUrl = (doc: any) => {
    if (!doc) return "";
    if (doc.url) return doc.url;
    if (doc.file) return doc.file;
    if (doc.fileSealed) return doc.fileSealed;
    if (doc.documentId && typeof doc.documentId === "string" && doc.documentId.startsWith("http")) {
      return doc.documentId;
    }
    return "";
  };

  const normalizeDocuments = (docs: any[]) =>
    (docs || []).map((doc) => {
      if (!doc) return doc;
      if (!doc.url && typeof doc.documentId === "string" && doc.documentId.startsWith("http")) {
        return { ...doc, url: doc.documentId };
      }
      return doc;
    });

  const getDocumentsSignature = (docs: any[] = []) =>
    (docs || [])
      .map((doc: any) => ({
        id: doc?.id || "",
        displayedName: doc?.displayedName || "",
        filename: doc?.filename || "",
        updatedAt: doc?.updatedAt || "",
      }))
      .map((doc) => `${doc.id}|${doc.displayedName}|${doc.filename}|${doc.updatedAt}`)
      .join("||");

  const buildIframeUrl = (
    fileUrl?: string | null,
    version?: string | number | null
  ) => {
    if (!fileUrl) return "";
    const normalizedVersion =
      version === undefined || version === null ? "" : String(version);
    const cacheBustedFileUrl = normalizedVersion
      ? `${fileUrl}${fileUrl.includes("?") ? "&" : "?"}v=${encodeURIComponent(normalizedVersion)}`
      : fileUrl;
    return `${process.env.REACT_APP_NOTARY_URL}/#/document/${encodeURIComponent(
      cacheBustedFileUrl
    )}`;
  };
  
  const handleDeleteDoc = async () => {
    if (deleteDocId) {
      setIsDeleteDocLoading(true);
      try {
        const deleteDocumentResponse = await dispatch(
          deleteDocumentSessionRequest({ sessionId: session.id, documentId: deleteDocId })
        );
        if (deleteDocumentResponse.meta.requestStatus == API_STATUS.fulfilled) {
          closeDeleteDocPopup();
          let filteredDocs = documents.filter((doc: any) => doc?.id != deleteDocId);
          filteredDocs = normalizeDocuments(filteredDocs);
          setIframeUrl(
            buildIframeUrl(
              getDocumentFileUrl(filteredDocs[0]),
              filteredDocs[0]?.updatedAt
            )
          );
          setDocuments(filteredDocs)
          toast.success("Document deleted", {
            autoClose: 3000,
            closeButton: <CustomCloseButton />,
            closeOnClick: false,
            icon: () => null,
          });
        } else {
          toast.error("Error while deleting", {
            autoClose: 3000,
            closeButton: <CustomCloseButton />,
            closeOnClick: false,
            icon: () => null,
          });
        }
        setIsDeleteDocLoading(false);
      } catch (err: any) {
        setIsDeleteDocLoading(false);
      }
    }
  };

  const handleDateEditClick = () => {
  };

  const handleDateChange = (
    date: Date | Date[] | null,
    event?: React.SyntheticEvent<any> | undefined
  ) => {
    if (date) {
      const selectedDate = Array.isArray(date) ? date[0] : date;
      setTempDate(selectedDate);
    }
  };

  const handleSaveDate = async () => {
    await handleUpdateDetails({ requestedDatetime: tempDate }, "scheduling");
    setSessionDate(tempDate);
  };

  const handleCancelDateEdit = () => {
    setTempDate(sessionDate);
    setIsDateEditable(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      datePickerRef.current &&
      !datePickerRef.current.contains(event.target as Node)
    ) {
      setIsDateEditable(false);
    }
  };

  useEffect(() => {
    setDeleteDocId(null);
    if (session?.id) {
      (async () => {
        const permissions = getFromLocalStorage("roles");
        const isAvailable = permissions?.includes("scheduler") ?? false;
        setIsAssignmentAvailable(isAvailable);
        const getOfficialsResponse = await dispatch(getOfficials({}));
        if (getOfficialsResponse.meta.requestStatus === "fulfilled") {
          setOfficials([...getOfficialsResponse.payload]);
          let tempSelectedOfficial = [...getOfficialsResponse.payload].find(
            function (official) {
              return session.assignedToUserId === official.uid;
            }
          );
          setSelectedNotaryOwner({
            label: tempSelectedOfficial?.name,
            value: tempSelectedOfficial?.name,
          });
          setAssignedToNotaryId(tempSelectedOfficial?.uid)
        }
        if (getOfficialsResponse.meta.requestStatus == "rejected") {
          toast.error("Something went wrong", { autoClose: 3000, closeButton: <CustomCloseButton />, closeOnClick: false, icon: () => null, }
          );
        }
      })();
    }
  }, [session?.id]);

  useEffect(() => {
    setIsDateEditable(false);
    if (session) {
      if (!isDocumentSealEditable) {
        setSelectedDocumentSeal(session?.documentsCount);
      }
      setTextareaValue(!session?.officialPrivateNotes ? session?.message : session?.officialPrivateNotes || "");
      setSignerDetail((prev) => ({
        ...prev,
        payerEmail: session?.payerEmail || "",
        userEmail: session?.userEmail || "",
        cc: session?.cc || "",
        copy2: session?.copy2 || "",
        appointmentType: session?.appointmentType || "",
        multipleSigner: session?.multipleSigner
          ? (session.multipleSigner === "yes" ? "yes" : "no")
          : "",
        signerPhone: session?.signerPhone || "",
        userTimezone: session?.userTimezone || "",
      }));
      setSelectedAppointmentType(
        appointmentTypes.find((type) => type.value === session?.appointmentType) ||
        appointmentTypes[0]
      );
      const initialDate = new Date(session?.requestedDatetime);
      setSessionDate(initialDate);
      const normalizedDocs = normalizeDocuments(session?.documents || []);
      setDocuments(normalizedDocs);
      setIframeUrl(
        buildIframeUrl(
          getDocumentFileUrl(normalizedDocs[0]),
          normalizedDocs[0]?.updatedAt
        )
      );
      setSelectedSessionStage({
        value: session?.stage,
        label: session?.stage,
      });

      const isNotaryAdminTemp = session.official?.roles
        ? session?.official?.roles.some((item: string) =>
          ["notaryAdmin", "scheduler", "remoteSignSessionCreator"].includes(
            item
          )
        )
        : false;
      setIsNotaryAdmin(isNotaryAdminTemp);
    }
  }, [session?.id, appointmentTypes]);

  useEffect(() => {
    if (!session?.documents) {
      return;
    }

    const normalizedDocs = normalizeDocuments(session?.documents || []);
    setDocuments((previousDocs: any[]) => {
      const previousSignature = getDocumentsSignature(previousDocs);
      const nextSignature = getDocumentsSignature(normalizedDocs);

      if (previousSignature === nextSignature) {
        return previousDocs;
      }

      setIframeUrl((previousIframeUrl) => {
        const currentDocStillExists = normalizedDocs.some((doc: any) => {
          const docUrl = buildIframeUrl(
            getDocumentFileUrl(doc),
            doc?.updatedAt
          );
          return docUrl === previousIframeUrl;
        });

        if (currentDocStillExists) {
          return previousIframeUrl;
        }

        return buildIframeUrl(
          getDocumentFileUrl(normalizedDocs[0]),
          normalizedDocs[0]?.updatedAt
        );
      });

      return normalizedDocs;
    });
  }, [session?.documents]);

  useEffect(() => {
    if (isDateEditable) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDateEditable]);


  const openAddDocPopup = () => {
    setIsAddDocPopupOpen(true);
  };

  const closeAddDocPopup = () => {
    setIsAddDocPopupOpen(false);
  };

  const handleCreateSession = () => {
    navigate("/createSession", {
      state: { session: { ...{ ...session, ...signerDetail }, documents: documents, assignedToUserId: assignedToNotaryId, documentsCount: selectedDocumentSeal, officialPrivateNotes: textareaValue }, isSessionInsideRequest: true, activeSessionId },
    });
  };

  const handleUndo = async (previousData: any) => {
    const updateSessionDetailResponse = await dispatch(
      updateSessionDetail({
        details: {
          ...previousData,
        },
        sessionId: session?.id,
      })
    );
    if (updateSessionDetailResponse.meta.requestStatus == "fulfilled") {
      toast.success("Changes have been undone", { autoClose: 3000, closeButton: <CustomCloseButton />, closeOnClick: false, icon: () => null, }
      );
    }
    if (updateSessionDetailResponse.meta.requestStatus == "rejected") {
      toast.error("Something went wrong", { autoClose: 3000, closeButton: <CustomCloseButton />, closeOnClick: false, icon: () => null, }
      );
    }
  };

  const handleUndoRequestDetail = async (previousData: any, type: string) => {
    const updateSessionDetailResponse = await dispatch(
      updateRequestDetail({
        details: {
          ...previousData,
        },
        requestId: session?.id,
      })
    );


    if (updateSessionDetailResponse.meta.requestStatus == "fulfilled") {
      if (type == "notes") {
        setTextareaValue(previousData?.extensions?.officialPrivateNotes)
      }
      if (type == "docSeal") {
        setSelectedDocumentSeal(previousData?.documentsCount)
      }
      toast.success("Changes have been undone", { autoClose: 3000, closeButton: <CustomCloseButton />, closeOnClick: false, icon: () => null, }
      );
    }
    if (updateSessionDetailResponse.meta.requestStatus == "rejected") {
      toast.error("Something went wrong", { autoClose: 3000, closeButton: <CustomCloseButton />, closeOnClick: false, icon: () => null, }
      );
    }
  };

  const handleDocument = async (document: any) => {
    setIframeUrl(
      buildIframeUrl(getDocumentFileUrl(document), document?.updatedAt)
    );
  };

  const addDocument = async (newDocuments: any[]) => {
    setDocuments((prev: any) => normalizeDocuments([...prev, ...newDocuments]));

    const updatedDocuments = [...session?.documents, ...newDocuments];
    if (updatedDocuments?.length > 0) {
      setIframeUrl(
        buildIframeUrl(
          getDocumentFileUrl(newDocuments[0]),
          newDocuments[0]?.updatedAt
        )
      );
    }
  };

  const handleUpdateDetails = async (data: any, type: string) => {
    let previousState = {};
    if (type == "sessionDetail") {
      previousState = {
        stage: session?.stage,
        documentsCount: session?.documentsCount,
      };
    }
    if (type == "notes") {
      previousState = {
        officialPrivateNotes: session?.officialPrivateNotes,
      };
    }
    if (type == "signerDetail") {
      previousState = {
        payerEmail: session?.payerEmail || "",
        cc: session?.cc || "",
        copy2: session?.copy2 || "",
        multipleSigner: session?.multipleSigner || "",
        appointmentType: session?.appointmentType || "",
        signerPhone: session?.signerPhone || "",
        userTimezone: session?.userTimezone || "",
      };
    }
    if (type == "notaryOwner") {
      previousState = {
        official: {
          ...session?.official,
        },
      };
    }
    if (type == "cancel") {
      previousState = {
        stage: session?.stage,
      };
    }
    if (type == "restart") {
      previousState = {
        stage: session?.stage,
        sessionId: session?.id,
        idImageFront: session?.idImageFront,
        selfieImage: session?.selfieImage,
        idCaptureError: session?.idCaptureError,
        latestSubStage: session?.latestSubStage,
        eventLog: session?.eventLog,
        idParts: session?.idParts,
        documentType: session?.documentType,
      };
    }
    if (type == "scheduling") {
      previousState = {
        scheduledAt: session?.scheduledAt,
      };
    }
    if (type == "settings") {
      previousState = {
        settings: {
          isMeetingDisabled: session?.isMeetingDisabled,
        },
      };
    }
    const updateSessionDetailResponse = await dispatch(
      updateRequestDetail({
        details: {
          extensions: {
            ...data,
          },
        },
        requestId: session?.id,
      })
    );
    if (updateSessionDetailResponse.meta.requestStatus == "fulfilled") {
      setIsDateEditable(false);
      setIsSessionDetailsEditable(false);
      toast.success(
        "Detail has been updated",
        { autoClose: 3000, closeButton: <CustomCloseButton />, closeOnClick: false, icon: () => null, }
      );
    }
    if (updateSessionDetailResponse.meta.requestStatus == "rejected") {
      toast.error("Something went wrong", { autoClose: 3000, closeButton: <CustomCloseButton />, closeOnClick: false, icon: () => null, }
      );
    }
  };

  const handleDownloadDoc = async (doc: any) => {
    try {
      const fileUrl = doc.url;
      if (!fileUrl) {
        throw new Error("No file URL found for this document.");
      }

      const parts = doc.filename?.split(".") || [];
      const ext = parts.pop();
      const filename = parts.join(".");

      const response = await fetch(fileUrl, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error("Failed to fetch file.");
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = `${filename}.${ext}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (err: any) {
      toast.error(err.message || "Failed to download document", {
        autoClose: 3000,
        closeButton: <CustomCloseButton />,
        closeOnClick: false,
        icon: () => null,
      });
    }
  };

  const handleCopyAppointmentId = () => {
    if (session?.appointmentId) {
      navigator.clipboard
        .writeText(session.appointmentId)
        .then(() => {
          toast.info("Appointment ID copied to clipboard!", { autoClose: 3000, closeButton: <CustomCloseButton />, closeOnClick: false, icon: () => null, }
          );
        })
        .catch(() => {
          toast.error("Failed to copy Appointment ID.", { autoClose: 3000, closeButton: <CustomCloseButton />, closeOnClick: false, icon: () => null, });
        });
    }
  };

  const closeRequestDocPopup = () => {
    setIsRequestDocPopupVisible(false);
  };

  const handleUploadLinkPopupClose = () => {
    setIsUploadLinkPopupOpen(false);
    setIsRequestDocPopupVisible(false);
  };

  const handleUploadLinkPopuOpen = () => {
    setIsUploadLinkPopupOpen(true);
  };

  const deletingRequest = async () => {
    try {
      setIsDeleteRequestLoading(true);
      const deleteRequestResponse = await dispatch(
        deleteRequest({ requestId: session?.id })
      );
      if (deleteRequestResponse.meta.requestStatus == API_STATUS.fulfilled) {
        toast.success("Request deleted", { autoClose: 3000, closeButton: <CustomCloseButton />, closeOnClick: false, icon: () => null, });

        navigate("/sessionRequests");
        setIsDeleteRequestPopupVisible(false);
      }
      setIsDeleteRequestLoading(false);
    } catch (err: any) {
      setIsDeleteRequestLoading(false);
      toast.error("Error while deleting the request", { autoClose: 3000, closeButton: <CustomCloseButton />, closeOnClick: false, icon: () => null, });
    }
  };

  const closeDeleteRequestPopup = () => {
    setIsDeleteRequestPopupVisible(false);
  };

  const openDeleteRequestPopup = () => {
    setIsDeleteRequestPopupVisible(true);
  };

  const handleDocumentSealChange = (newValue: number) => {
    if (newValue !== session?.documentsCount) {
      setSelectedDocumentSeal(newValue);
      setUpdatedDocumentSeal(newValue);
      setIsDocumentSealEditable(true);
      setIsNotaryOwnerEditable(false)
    } else {
      setIsDocumentSealEditable(false);
    }
  };

  const handleAppointmentTypeChange = (
    newValue: SingleValue<OptionType>,
    actionMeta: ActionMeta<OptionType>
  ) => {
    if (newValue) {
      setSelectedAppointmentType(newValue);
      setSignerDetail((prevState) => ({
        ...prevState,
        appointmentType: newValue.value || "",
      }));
    }
  };

  return (
    <Container>
      <NotaryActionBox>
        <FirstColumn>
          <NameContainer>
            <Name>{session?.name}</Name>
            <HandleSessionContainer>
              <CreateSessionButton onClick={handleCreateSession}>
                Schedule session
              </CreateSessionButton>
              <DeleteIcon
                onClick={openDeleteRequestPopup}
                style={{ cursor: "pointer" }}
              />
            </HandleSessionContainer>
          </NameContainer>

        </FirstColumn>
        <SecondColumn>
          <IntroDetail>

            <DateContainer>
              <StyledDate onClick={handleDateEditClick}>
                {moment(sessionDate).format("MMMM D, YYYY h:mm A")}
              </StyledDate>
              {isDateEditable && (
                <DatePickerWrapper ref={datePickerRef}>
                  <DatePicker
                    selected={tempDate}
                    onChange={handleDateChange}
                    inline
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    dateFormat="MMMM d, yyyy h:mm aa"
                    timeCaption="Time"
                  />
                  <ButtonGroupDate>
                    <Button onClick={handleCancelDateEdit} variant="cancel">
                      Cancel
                    </Button>
                    <Button onClick={handleSaveDate} variant="save">
                      {updateLoading ? <LoadingSpinner /> : "Save"}
                    </Button>
                  </ButtonGroupDate>
                </DatePickerWrapper>
              )}
            </DateContainer>

            <AppoitmentId onClick={handleCopyAppointmentId}>

              <AppoitmentIdTitle>Appointment ID </AppoitmentIdTitle>
              {session?.appointmentId}
            </AppoitmentId>
          </IntroDetail>
          <NotaryOwnerBox>
            {!isAssignmentAvailable && selectedNotaryOwner?.name ? (
              <>
                <NotaryTitle>Notary</NotaryTitle>
                <span>{selectedNotaryOwner?.label}</span>
              </>
            ) : (
              <>
                <NotaryTitle>Notary</NotaryTitle>
                <Dropdown
                  onChange={handleChangeNotaryOwner}
                  value={selectedNotaryOwner}
                  options={officials.map((item) => {
                    return { value: item.name, label: item.name };
                  })}
                />
              </>
            )}
          </NotaryOwnerBox>
          <DocumentSealBox>
            <DocumentSealTitle>Documents/seals</DocumentSealTitle>
            <Counter
              value={selectedDocumentSeal || 0}
              onChange={handleDocumentSealChange}
            />
          </DocumentSealBox>
        </SecondColumn>
        {(isDocumentSealEditable) && (
          <ButtonGroup>
            <Button onClick={handleDocSealCancel} variant="cancel">
              Cancel
            </Button>
            <Button onClick={handleDocSealSave} variant="save">
              {isDocSealSaveLoading ? <LoadingSpinner /> : "Save"}
            </Button>
          </ButtonGroup>
        )}
        {isNotaryOwnerEditable && (
          <ButtonGroup>
            <Button onClick={handleNotaryOwnerCancel} variant="cancel">
              Cancel
            </Button>
            <Button onClick={handleNotaryOwnerSave} variant="save">
              {isNotaryOfficialSaveLoading ? <LoadingSpinner /> : "Save"}
            </Button>
          </ButtonGroup>
        )}

      </NotaryActionBox>
      <NotesActionBox>
        <ThirdColumn >
          <NotesContainer>
            <NotesSubBox>
              <NotesContentBox>
                <NotesHeader>
                  <NotesTitle>Notes</NotesTitle>
                </NotesHeader>

                <FloatingLabelTextarea
                  ref={textareaRef}
                  label=""
                  value={textareaValue ? textareaValue : ""}
                  onChange={handleTextareaChange}
                  onFocus={handleTextareaFocus}
                  onBlur={handleTextareaBlur}
                  readOnly={!isNotesEditable}
                  maxLength={300}
                  rows={1}
                />
              </NotesContentBox>
              <WordCount>
                {textareaValue?.length} / {300}
              </WordCount>
            </NotesSubBox>

            {isNotesEditable && (
              <ButtonGroup>
                <Button onClick={handleNotesCancel} variant="cancel">
                  Cancel
                </Button>
                <Button onClick={handleNotesSave} variant="save">
                  {isNotesLoading ? <LoadingSpinner /> : "Save"}
                </Button>
              </ButtonGroup>
            )}
          </NotesContainer>
        </ThirdColumn>

      </NotesActionBox>
      <SignerDetailBox>
        <SignerTitle>
          Signer Detail{" "}
          {!isSignerDetailEditable && (
            <EditIcon onClick={handleSignerDetailEditClick} />
          )}
        </SignerTitle>
        <Columns>
          {Object.keys(signerDetail).map((key, index) => (
            <Column key={index}>
              <ColumnName>
                {labelMapping[key] || key.split(/(?=[A-Z])/).join(" ")}
              </ColumnName>
              {isSignerDetailEditable ? (
                key === "appointmentType" ? (
                  <Dropdown
                    options={appointmentTypes}
                    value={selectedAppointmentType}
                    onChange={handleAppointmentTypeChange}
                  />
                ) : key === "multipleSigner" ? (
                  <Dropdown
                    options={signersOptions}
                    value={signersOptions.find(option => option.value === (signerDetail.multipleSigner === "yes" ? "yes" : "no")) || signersOptions[0]}
                    onChange={(newValue) => {
                      if (newValue) {
                        setSignerDetail((prevState) => ({
                          ...prevState,
                          multipleSigner: newValue.value === "yes" ? "yes" : "no",
                        }));
                      }
                    }}
                  />

                ) :
                  key === "userTimezone" ? (
                    <StyledSelect
                      name={key}
                      value={(signerDetail as any)[key]}
                      onChange={handleSignerDetailChange}
                      required
                    >
                      <option value="">Select Time Zone</option>
                      {TIME_ZONES.map((zone) => (
                        <option key={zone.name} value={zone.value}>
                          {zone.name}
                        </option>
                      ))}
                    </StyledSelect>
                  ) : (
                    <ColumnValue
                      name={key}
                      value={(signerDetail as any)[key]}
                      onChange={handleSignerDetailChange}
                      isEditable={
                        key == "cc" ||
                          key == "copy2" ||
                          key == "payerEmail"
                          ? isSignerDetailEditable
                          : false
                      }
                    />
                  )
              ) : (
                <ColumnValue
                  isEditable={
                    key === "cc" ||
                      key === "copy2" ||
                      key === "payerEmail"
                      ? isSignerDetailEditable
                      : false
                  }
                  readOnly
                  value={key === "multipleSigner"
                    ? (signerDetail.multipleSigner === "yes" ? "Multiple" : "Single")
                    : (signerDetail as any)[key]
                  }
                />

              )}
            </Column>
          ))}
        </Columns>
        {isSignerDetailEditable && (
          <ButtonGroupSignerDetail>
            <Button onClick={handleSignerDetailCancel} variant="cancel">
              Cancel
            </Button>
            <Button onClick={handleSignerDetailSave} variant="save">
              {isLoadingUpdateSignerDetail ? <LoadingSpinner /> : "Save"}
            </Button>
          </ButtonGroupSignerDetail>
        )}
      </SignerDetailBox>

      <TabBox>
        <Tabs>
          <IconsBox>
            <NewDocumentIcon
              onClick={() => openAddDocPopup()}
              style={{
                width: "30px",
                height: "30px",
              }}
            />
            <EditIconSvg
              onClick={handleEditSessionRequestDocuments}
              style={{
                width: "30px",
                height: "30px",
              }}
            />
          </IconsBox>
        </Tabs>
        <TabContent>
          <IframeHeader>
            {documents.map((document: any) => {
              return (
                <IframeHeaderBox
                  onClick={() => handleDocument(document)}
                >
                  <DocName>{document?.displayedName}</DocName>
                  <IconsBox>

                    <DownloadIcon
                      style={{
                        width: "23px",
                        height: "23px",
                        cursor: "pointer"
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDownloadDoc(document);
                      }}
                    />
                    <TrashIcon
                      style={{
                        width: "23px",
                        height: "23px",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        openDeleteDocPopup();
                        setDeleteDocId(document?.id);
                      }}
                    />
                  </IconsBox>
                </IframeHeaderBox>
              );
            })}
          </IframeHeader>
          {documents?.length > 0 && (
            <StyledIframe
              key={iframeUrl}
              ng-show="showCanvas"
              ng-src={iframeUrl}
              aria-hidden="false"
              className=""
              src={iframeUrl}
            ></StyledIframe>
          )}
        </TabContent>
      </TabBox>
      {isRequestDocPopupVisible && (
        <RequestDocumentPopup
          onClose={closeRequestDocPopup}
          session={session}
          onSuccess={handleUploadLinkPopuOpen}
        />
      )}
      {isUploadLinkPopupOpen && (
        <UploadLinkPopup
          onClose={handleUploadLinkPopupClose}
          session={session}
        />
      )}
      {isDeleteDocPopupVisible && (
        <PopupOverlay>
          <PopupContainer onClick={(e) => e.stopPropagation()}>
            <PopupDescription>
              Are you sure you want to delete this document ?
            </PopupDescription>

            <ButtonCheckBox>
              <RestartButtonGroup>
                <Button onClick={() => handleDeleteDoc()} variant="save">
                  {isDeleteDocLoading ? <LoadingSpinner /> : "Yes"}
                </Button>
                <Button onClick={closeDeleteDocPopup}>No</Button>
              </RestartButtonGroup>
            </ButtonCheckBox>
          </PopupContainer>
        </PopupOverlay>
      )}
      {isDeleteRequestPopupVisible && (
        <PopupOverlay onClick={closeDeleteRequestPopup}>
          <PopupContainer onClick={(e) => e.stopPropagation()}>
            <PopupHeader>
              Are you sure you want to delete this request?
            </PopupHeader>
            <ButtonGroup>
              <DynamicButton onClick={() => deletingRequest()} variant="save">
                {isDeleteRequestLoading ? <LoadingSpinner /> : "Yes"}
              </DynamicButton>
              <DynamicButton onClick={closeDeleteRequestPopup}>
                Cancel
              </DynamicButton>
            </ButtonGroup>
          </PopupContainer>
        </PopupOverlay>
      )}
      <AddDocPopup
        open={isAddDocPopupOpen}
        onClose={closeAddDocPopup}
        addDocument={addDocument}
        requestId={session?.id}
        setSelectedDocumentSeal={setSelectedDocumentSeal}
        sessionDate={sessionDate}
      />
    </Container>
  );
};

export default SessionSummary;
const Container = styled.div`
  flex: 69.35; 
  height: fit-content;
  background: #f9f9f9;
  padding: 17.1px; 
  overflow: hidden;
  @media (max-width: 768px) {
    flex: none;
    width: 100%;
  }
  ::-webkit-scrollbar {
    display: none;
  }
  overflow: hidden;
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 114vh; 
  border: none;
  overflow: hidden;
`;

const NotaryOwnerBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8.55px; 
  border-radius: 8.55px; 
`;

const NotaryTitle = styled.div`
  color: ${(props) => props.theme.colors.secondary};
  font-weight: 500;
`;

const NotaryActionBox = styled.div`
  background: white;
  padding: 21.85px 26.6px; 
  padding-bottom: 13px; 
  border-radius: 8.55px; 
`;

const FirstColumn = styled.div`
  display: flex;
  margin-bottom: 17.1px; 
  padding-bottom: 10.07px; 
  border-bottom: ${(props) => `1.9px solid ${props.theme.colors.normal}`}; 
`;

const NameContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8.55px; 
  justify-content: space-between;
`;

const Name = styled.span`
  font-size: 30.4px; 
  color: black;
  font-weight: 800;
`;

const SecondColumn = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 15.68px; 
  border-radius: 6.94px; 
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 22.23px 25.65px; 
  }
`;

const ThirdColumn = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 15.68px; 
  border-radius: 6.94px; 
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 22.23px 25.65px; 
  }
`;
const IntroDetail = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4.56px; 
`;

const StyledDate = styled.span`
  display: flex;
  font-size: 14.82px; 
  font-weight: 500;
  color: black;
  cursor: pointer;
`;

const AppoitmentId = styled.span`
  display: flex;
  font-size: 14.82px; 
  font-weight: 500;
  cursor: pointer;
  color: black;
`;

const AppoitmentIdTitle = styled.span`
  font-size: 14.82px; 
  font-weight: 500;
  margin-right: 6.94px; 
`;

const SignerDetailBox = styled.div`
  padding: 17.1px; 
  word-wrap: break-word;
  overflow-wrap: break-word;
  display: flex;
  flex-direction: column;
  background: white;
  margin-top: 15.39px; 
  border-radius: 8.55px; 
  border-left: 6.65px solid #c1d3f5; 
`;

const SignerTitle = styled.h3`
  text-align: left;
  margin-bottom: 30.69px; 
  font-size: 17.1px; 
  margin-top: 0px;
  display: flex;
  align-items: center;
  gap: 7.6px; 
`;

const Columns = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  row-gap: 28.02px; 
  column-gap: 15.2px; 
  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6.65px; 
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

const ColumnName = styled.div`
  color: grey;
  font-size: 11.97px; 
`;

const ColumnValue = styled.input<{ isEditable: boolean }>`
  color: black;
  font-size: 13.68px; 
  font-weight: 380; 
  word-wrap: break-word;
  overflow-wrap: break-word;
  border: 0.95px solid #ccc; 
  border-radius: 3.8px; 
  padding: 6.94px; 
  width: 100%;
  box-sizing: border-box;
  white-space: nowrap;
  overflow-x: scroll;
  background-color: #f9f9f9;
  cursor: ${(props) => (props.isEditable ? "text" : "default")};
  scrollbar-width: none; /* Hides scrollbars */
  &::-webkit-scrollbar {
    display: none; /* Hides scrollbars */
  }
`;


const TabBox = styled.div`
  background-color: white;
  margin-top: 14.82px; 
  border-radius: 8.55px; 
`;

const TabContent = styled.div`
  padding: 17.1px; 
  padding-top: 10px; 
  background-color: white;
  // margin-top: 22.23px; 
  overflow: hidden; /* Hides scrollbars */
  border-radius: 18.05px; 
`;

const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const PopupHeader = styled.h2`
  text-align: center;
`;

const PopupDescription = styled.h4`
  text-align: left;
  margin-right: auto;
  font-weight: 380; 
`;

const ButtonCheckBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 13.3px; 
  gap: 8.55px; 
`;

const ButtonGroupSignerDetail = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8.55px; 
  margin-top: 10.26px; 
`;

const RestartButtonGroup = styled(ButtonGroup)`
  margin-left: auto;
`;

const PopupContainer = styled.div`
  background-color: white;
  padding: 17.1px; 
  border-radius: 7.6px; 
  box-shadow: 0 3.8px 5.7px rgba(0, 0, 0, 0.1); 
  width: 368.6px; 
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const InputLabel = styled.label<{ isFocused: boolean }>`
  position: absolute;
  left: ${(props) => (props.isFocused ? "11.4px" : "22.8px")}; 
  top: ${(props) => (props.isFocused ? "-9.5px" : "19px")}; 
  color: ${(props) => (props.isFocused ? "#007bff" : "grey")};
  font-size: ${(props) => (props.isFocused ? "11.4px" : "15.2px")}; 
  transition: all 0.3s ease;
  pointer-events: none;
`;

const NotesActionBox = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  margin-top: 23.75px; 
  width: 57%; 
  border-radius: 9.5px; 
  padding: 21.85px 26.6px; 
  padding-top: 0px;
  padding-bottom: 7.6px; 
  overflow: hidden; /* Hides scrollbars */
`;

const NotesHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 9.5px; 
`;

const NotesTitle = styled.div`
  color: ${(props) => props.theme.colors.secondary};
  font-weight: 500;
  font-size: 15.2px; 
`;

const LoadingSpinner = styled.div`
  border: 4.18px solid rgba(0, 0, 0, 0.1); 
  border-top: 2.09px solid white; 
  width: 11.4px; 
  height: 11.4px; 
  border-radius: 50%; /* Ensures the element is a perfect circle */
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const DateContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const DatePickerWrapper = styled.div`
  position: absolute;
  z-index: 1000;
  background-color: white;
  border: 0.95px solid #ccc; 
  border-radius: 7.6px; 
  box-shadow: 0 3.8px 5.7px rgba(0, 0, 0, 0.1); 
  padding: 9.5px; 

  .react-datepicker {
    display: flex;
  }
`;
const ButtonGroupDate = styled.div`
  display: flex;
  gap: 8.55px; 
  margin-top: 8.55px; 
`;

const HandleSessionContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-end;
  gap: 41.8px; 
`;

const Button = styled.button<{ variant?: string }>`
  padding: 6.94px 13.68px; 
  border-radius: 3.8px; 
  border: none;
  cursor: pointer;

  ${({ variant }) =>
    variant === "save" &&
    `
    background-color: #007bff;
    color: white;
  `}

  ${({ variant }) =>
    variant === "cancel" &&
    `
    background-color: transparent;
    border: 0.95px solid #007bff; 
    color: #007bff;
  `}
`;

const CreateSessionButton = styled.button`
  padding: 12.35px; 
  background-color: #06B050;
  color: white;
  border: none;
  border-radius: 7.6px; 
  cursor: pointer;
  font-size: 14.73px; 
`;

const StyledSelect = styled.select`
  padding: 8.55px; 
  font-size: 11.97px; 
  border: 0.95px solid #ccc; 
  border-radius: 6.94px; 
  width: 100%;
  box-sizing: border-box;
  appearance: none;
  background: url("path/to/your/custom/dropdown-icon.png") no-repeat right;
  background-position-x: calc(100% - 9.5px); 
`;
const IconsBox = styled.div`
  display: flex;
  cursor: pointer;
  justify-content: space-between;
  gap: 15.39px;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
`;

const IframeHeaderBox = styled.div`
  display: flex;
  justify-content: space-between;
  overflow: hidden; /* Hides scrollbars */
  padding-top: 5.99px; 
  padding-bottom: 5.99px; 
`;

const IframeHeader = styled.div``;

const DocName = styled.span`
  display: flex;
  font-size: 13.68px; 
  font-weight: 500;
  color: ${(props) => props.theme.colors.primary};
  cursor: pointer;
`;

const DynamicButton = styled.button<{ variant?: string }>`
  padding: 6.94px 13.68px; 
  border-radius: 3.8px; 
  border: none;
  cursor: pointer;

  ${({ variant }) =>
    variant === "save" &&
    `
    background-color: #007bff;
    color: white;
  `}

  ${({ variant }) =>
    variant === "cancel" &&
    `
    background-color: transparent;
    border: 0.95px solid #007bff; 
    color: #007bff;
  `}
`;

const DocumentSealBox = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10.26px; 
  border-radius: 8.55px; 
  flex: 1;
`;

const DocumentSealTitle = styled.div`
  color: ${(props) => props.theme.colors.secondary};
  font-size: 14.71px; 
  max-width: 128.25px; 
`;

const NotesSubBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
  justify-content: flex-end;
  background: white;
  padding-bottom: 3.42px; 
  border-radius: 8.55px; 
`;

const NotesContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const NotesContentBox = styled.div`
  display: flex;
  gap: 8.55px; 
`;

const WordCount = styled.div`
  font-size: 10.26px; 
  color: grey;
  text-align: right;
`;


const EditIcon = styled(MdOutlineEdit)`
  color: #007bff;
  cursor: pointer;
  &:hover {
    color: ${(props) => props.theme.colors.dark};
  }
`;

const Tabs = styled.div`
  display: flex;
  margin-top: 17.1px; 
  border-bottom: 1.71px solid #ccc; 
  justify-content: flex-end;
`
